export default __webpack_public_path__ + "e0c2c1e819c2141bdf3d6366858cad0a.png";